import React, {useEffect, useState} from 'react';
import MonitorIcon from '../Assets/SVG/MonitorIcon';
import {RouterSelfInstallSteps} from '../Assets/variables';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {getReportParams, report} from 'app/middleware/report';

const SelfcheckScreen = (props) => {
  const reportSuccess = () => {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'Support';
    reportParams.subArea = 'SelfSetupRouterProcess';
    reportParams.actionType = 'Process completion indicator displayed';
    reportParams.status = 'Completed';
    reportParams.messageText = 'Process completed and indicator displayed';
    report(reportParams);
  };
  const reportFailure = () => {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'Support';
    reportParams.subArea = 'SelfSetupRouterProcess';
    reportParams.actionType = 'Process completion indicator displayed';
    reportParams.status = 'Error';
    reportParams.messageText = 'Process completion failed – error received';
    report(reportParams);
  };
  return (
    <>
      <MonitorIcon />
      <div className='headBox'>
        <p className='heading'>זהו, הניוד הצליח! </p>
        <p className='subHeading'>
          כדאי להתחבר ממכשיר אחר לרשת החדשה <br />
          ולוודא שהכל עובד
        </p>
      </div>
      <div className='fixFooter'>
        <p className='subHeading' style={{fontWeight: 600}}>
          הצלחת להתחבר?
        </p>
        <div className='proceedBtnContainer'>
          <BtnSubmit
            className='mb-12'
            text={'הצלחתי'}
            onclick={() => {
              reportSuccess();
              props.getWizardStep({requestId: props.reqId, isSuccess: true, shouldEnd: true});
              props.setStep(RouterSelfInstallSteps.SUCCESS);
            }}
          />
          <BtnSubmit
            className='mb-12'
            text={'לא עבד לי'}
            onclick={() => {
              reportFailure();
              props.getWizardStep({requestId: props.reqId, isSuccess: false, shouldEnd: true});
              props.setError({...props.error, radiusError: true, isError: true});
              props.setStep(RouterSelfInstallSteps.ERROR);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default SelfcheckScreen;
